import React from 'react'

import format from "date-fns/format";

import { Collapse } from "components/Collapse";
import Button from "components/Safra/Button";
import SearchHotel from "components/Safra/SearchHotel";
import {SummaryContainer, SummaryContent, SummaryTitle, SummaryDetails, EditButton} from './styles'

import { useApp } from "contexts/AppContext";
import { useTranslation } from "contexts/Safra/TranslationContext";
import {isChannel} from "../../../utils";
import {useGenialApp} from "../../../contexts/GenialAppContext";

export default function SearchBarHotels({info, handleInfo, searchHotels}) {

    const { t } = useTranslation();
    const { hotelState } =  !isChannel('genial') ? useApp() : useGenialApp()
    const { locationSearchHotel, datesSearchHotel, guestsSearchHotel } = hotelState
    const { adults, children } = guestsSearchHotel
    const totalGuests = adults + children

    const handleRedoSearch = () => {
        searchHotels(true);
    }

    return (
        <div>
            { info && (
                <SummaryContainer onClick={handleInfo} data-bs-toggle="collapse" data-bs-target="#filter-collapse" aria-expanded="false" aria-controls="filter-collapse">
                    <SummaryContent>
                        <SummaryTitle>{locationSearchHotel?.name ? locationSearchHotel.name.split('/')[0].trim() : '-'}</SummaryTitle>
                        <SummaryDetails>
                            {datesSearchHotel.startDate ? format(datesSearchHotel.startDate, "dd/MM/yy") : '-'} - {datesSearchHotel.endDate ? format(datesSearchHotel.endDate, "dd/MM/yy") : '-'} • {totalGuests} {totalGuests === 1 ? t('safra.components.search_bar.guest') : t('safra.components.search_bar.guests')}
                        </SummaryDetails>
                    </SummaryContent>
                    <EditButton>{t('safra.components.search_bar.edit')}</EditButton>
                </SummaryContainer>
            )}
            <Collapse handleClick={handleInfo}>
                <p className="fw-bolder mb-0" style={{ fontSize: '16px', fontWeight: 600, paddingTop: '16px' }}>{t('safra.components.search_bar.new_hotel_search')}</p>

                <SearchHotel />

                <div className="mb-3">
                    <Button
                        onClick={handleRedoSearch}
                        width="100%"
                        style={{
                            borderRadius: '4px',
                            fontFamily: 'Montserrat, sans-serif',
                            fontSize: '14px',
                            fontWeight: 600,
                            letterSpacing: '0%',
                            lineHeight: '100%',
                            padding: '16px'
                        }}
                    >
                        {t('safra.home.cta_hoteis')}
                    </Button>
                </div>

            </Collapse>
        </div>
    )
}
